<template>
    <v-dialog v-model="smsModal" max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4  class="modal-headline">{{ $page.props.lang.new_message || 'New Message' }}</h4>
                <v-btn icon @click="smsModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="responseErrors.credit" type="error">
                            <span v-for="item in responseErrors.credit" :key="item">{{item}}</span>
                        </v-alert>
                        <div class="fields">
                            <div class="form-group">
                            <label class="custom-label">{{ $page.props.lang.recipients || 'Send to' }}</label>
                            <v-combobox
                                v-model="filteredReceptiants"
                                :items="recipients"
                                item-text="full_name"
                                item-value="id"
                                chips
                                multiple
                                variant="outlined"
                                return-object>
                                <template v-slot:selection="{ attrs, item, select, selected }">
                                <v-chip
                                    v-bind="attrs"
                                    :model-value="selected"
                                    closable
                                    close
                                    small
                                    @click="select"
                                    @click:close="filterRecipents(item.id)"
                                    style="margin:1px 1px; padding-left:1px">
                                    <v-avatar size="10">
                                        <img :src="item.profile_photo_url">
                                    </v-avatar>
                                    <span style="padding-left:5px">{{ item.full_name }}</span>
                                </v-chip>
                                </template>
                            </v-combobox>
                            </div>
                            <div v-if="use_mobile_app == 1" class="mb-2">
                                <v-radio-group v-model="message.type" row dense>
                                    <v-radio label="SMS" :value=2></v-radio>
                                    <v-radio :label="$page.props.lang.is_push_message || 'Push'" :value=3></v-radio>
                                </v-radio-group>
                            </div>
                            <div v-if="message.type == 3" class="form-group">
                                <label class="custom-label">{{ $page.props.lang.subject || 'Subject' }}</label>
                                <v-text-field v-model="message.subject" :error-messages="responseErrors.subject" 
                                    :hide-details="!responseErrors.subject" outlined dense></v-text-field>
                            </div>
                            <div class="form-group">
                                <v-row>
                                    <v-col style="padding:0 12px">
                                        <label class="custom-label">{{ $page.props.lang.enter_message || 'Enter your message:' }}</label>
                                    </v-col>
                                    <v-col style="padding:0 12px">
                                          <p class="text-right" >{{messageStatus.length}}/{{messageStatus.messages}}</p>
                                    </v-col>
                                </v-row>
                                <v-textarea style="margin-bottom:10px" v-model="message.content" outlined dense
                                    :error-messages="responseErrors.content" 
                                    :hide-details="!responseErrors.content"></v-textarea>
                                <v-btn @click="addPlaceholder('{first_name}')" x-small color="primary">{{ $page.props.lang.first_name || 'First name' }}</v-btn> 
                                <v-btn @click="addPlaceholder('{last_name}')" x-small color="primary">{{ $page.props.lang.last_name || 'Last name' }}</v-btn>
                            </div>   
                        </div>
                        <v-card-actions>
                            <span v-if="message.type == 2">{{ $page.props.lang.sms_credit || "SMS Credit" }}: {{sms_credit | round(2)}}</span>
                            <v-spacer></v-spacer>
                            <v-btn color="regular" @click="smsModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn color="primary" @click="sendSms()" :loading="sending">{{ $page.props.lang.send || "Send" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { VueEditor } from "vue2-editor";
import SmsCount from "./../../../../plugins/smsCount";
import throttle from 'lodash/throttle'
import EventBus from '@/js/eventbus'

export default {
    components: { VueEditor },
    props: {
        open: Boolean,
        sms_credit: Number,
        recipients: Array,
        use_mobile_app: Number
    },

    data(){
      return {
           message:{
              members:[],
              content:'',
              type:2
        },
        radios: 2,
        sending: false,
        filteredReceptiants: [],
        messageStatus: {
            length: 0,
            messages: 1,
            per_message: 160,
            remaining: 160
        },
        responseErrors:{},
        customToolbar: [''],
        editorOptions: {
        modules: {
            toolbar: false,
        },
        }
      }
    },
    computed: {
        smsModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
    created(){
        this.filteredReceptiants = this.recipients;
    },
    watch: {
        'message.content': {
            handler: throttle(function(value) {
               this.messageStatus = SmsCount.count(value);
            }, 250)
        }
    },
    methods: {
        addRecipients(){
            this.message.members = this.filteredReceptiants.map(function(el){
                return el.id;
            });
        },
        filterRecipents(id){
            this.filteredReceptiants = this.filteredReceptiants.filter(rec => rec.id !== id);
        },
        addPlaceholder(placeholder){
            this.message.content += placeholder;
        },
        sendSms() {
            this.sending = true;
            this.addRecipients();
            axios.post('/backoffice/messages/send', this.message)
                .then(response => {
                    var color = 'success';
                    this.sending = false;
                    if (response.data.status === "OK") {
                        this.smsModal = false;
                    } else {
                        color = 'error';
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: color,
                        timeout: 5000
                    })

                })
                .catch(error => {
                    this.sending = false;
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                });
        }
    }
}
</script>
